import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import type { ExtensionLoadGql } from '../../model/graphql/index.tsx';
import { fetchExtensionData } from '../../rest/load-extension-data/index.tsx';
import type { ServiceContext } from '../service-context/index.tsx';

export function loadExtensionDataService(ctx: ServiceContext): Observable<ExtensionLoadGql> {
	if (ctx.isCompanyManaged) {
		return Observable.empty<ExtensionLoadGql>();
	}

	return fetchExtensionData('', ctx.boardId);
}
